var map = {
	"./chevron-right-alt.svg": 4209,
	"./chevron-right-black.svg": 3528,
	"./chevron-right-blue.svg": 8807,
	"./chevron-right.svg": 9937,
	"./facebook.svg": 8535,
	"./gradient.svg": 1209,
	"./icon-accounting.svg": 6619,
	"./icon-admin.svg": 479,
	"./icon-arrow-circle-down.svg": 1950,
	"./icon-award.svg": 4408,
	"./icon-book.svg": 6655,
	"./icon-building.svg": 10,
	"./icon-calculator.svg": 8346,
	"./icon-calendar-orangegrad.svg": 205,
	"./icon-calendar.svg": 5996,
	"./icon-cart-full.svg": 3948,
	"./icon-cart.svg": 8372,
	"./icon-categories.svg": 6777,
	"./icon-category.svg": 5529,
	"./icon-check-box-fill.svg": 3851,
	"./icon-chevron-down.svg": 1400,
	"./icon-clock.svg": 756,
	"./icon-cross.svg": 3683,
	"./icon-dropdown.svg": 3064,
	"./icon-enter.svg": 6492,
	"./icon-facebook.svg": 2225,
	"./icon-half-star.svg": 7650,
	"./icon-hat.svg": 4817,
	"./icon-info.svg": 2158,
	"./icon-instagram.svg": 1033,
	"./icon-learning-test.svg": 7289,
	"./icon-learning.svg": 8597,
	"./icon-left-arrow.svg": 7256,
	"./icon-level.svg": 4150,
	"./icon-linkedin.svg": 4823,
	"./icon-list-item.svg": 6462,
	"./icon-live-event.svg": 3827,
	"./icon-lock.svg": 9349,
	"./icon-minus-circle.svg": 2341,
	"./icon-people.svg": 9319,
	"./icon-play.svg": 4391,
	"./icon-plus-circle.svg": 3387,
	"./icon-plus.svg": 7116,
	"./icon-quote-marks.svg": 2846,
	"./icon-right-arrow.svg": 9365,
	"./icon-rocket.svg": 1012,
	"./icon-search.svg": 2868,
	"./icon-small-chevron-down.svg": 2959,
	"./icon-spotlight.svg": 9851,
	"./icon-star.svg": 245,
	"./icon-team.svg": 1327,
	"./icon-tick-circled.svg": 581,
	"./icon-tick-square.svg": 6426,
	"./icon-tick.svg": 8774,
	"./icon-tiktok.svg": 8735,
	"./icon-time-orangegrad.svg": 7636,
	"./icon-time.svg": 166,
	"./icon-twitter.svg": 4339,
	"./icon-youtube.svg": 5057,
	"./linkedin.svg": 8275,
	"./pryor-footer-logo.svg": 7932,
	"./twitter.svg": 6786
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4102;